import { Badge, HStack } from '@chakra-ui/react'
import type { InvoiceStatusUi } from '../domain/types'

type Props = {
  status: InvoiceStatusUi | null
}

function getColorPalette(tone: InvoiceStatusUi['tone']) {
  if (tone === 'success') {
    return {
      labelPalette: 'green',
      sublabelPalette: 'green',
    }
  }

  if (tone === 'danger') {
    return {
      labelPalette: 'red',
      sublabelPalette: 'red',
    }
  }

  return {
    labelPalette: 'gray',
    sublabelPalette: 'yellow',
  }
}

export function InvoiceStatusBadge({ status }: Props) {
  if (!status) {
    return null
  }

  const fallback = getColorPalette(status.tone)
  const labelPalette = status.labelPalette ?? fallback.labelPalette
  const sublabelPalette = status.sublabelPalette ?? fallback.sublabelPalette

  return (
    <HStack gap="2" wrap="wrap">
      <Badge
        borderRadius="full"
        px="3"
        py="1"
        colorPalette={labelPalette}
        variant="solid"
        size="sm"
      >
        {status.label}
      </Badge>

      {status.sublabel && (
        <Badge
          borderRadius="full"
          px="3"
          py="1"
          colorPalette={sublabelPalette}
          variant="subtle"
          size="sm"
          boxShadow={
            sublabelPalette === 'yellow'
              ? 'inset 0 0 0 1px var(--chakra-colors-yellow-muted)'
              : undefined
          }
        >
          {status.sublabel}
        </Badge>
      )}
    </HStack>
  )
}
